module.exports = __webpack_public_path__ + "img/rotate_right.86d35c7e.svg";